import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Gift, ShieldCheck, Apple, Activity, Heart, Moon } from 'lucide-react';
export function PricingCTA() {
  const bonuses = [{
    icon: <Apple className="w-5 h-5 text-warm-accent" data-id="element-199" />,
    title: 'Guía de alimentación antiinflamatoria',
    desc: 'Aprende qué hábitos alimenticios pueden ayudarte a reducir inflamación y sentir más alivio en tu día a día.'
  }, {
    icon: <Activity className="w-5 h-5 text-warm-accent" data-id="element-200" />,
    title: 'Rutina diaria de ejercicios',
    desc: 'Movimientos suaves y progresivos para ayudarte a recuperar confianza y movilidad.'
  }, {
    icon: <Heart className="w-5 h-5 text-warm-accent" data-id="element-201" />,
    title: 'Guía emocional para los días difíciles',
    desc: 'Herramientas para manejar el miedo, la frustración y el agotamiento mental del dolor crónico.'
  }, {
    icon: <Moon className="w-5 h-5 text-warm-accent" data-id="element-202" />,
    title: '3 meditaciones guiadas',
    desc: 'Antes de dormir · Para vencer el miedo al movimiento · Para acompañarte en los días difíciles.'
  }];
  return <section id="comprar" className="py-24 bg-sage/10 relative" data-id="element-203">
      <div className="max-w-4xl mx-auto px-6" data-id="element-204">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-sage/20 relative overflow-hidden" data-id="element-205">
          <div className="absolute top-0 right-0 w-64 h-64 bg-sage/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-206"></div>

          <div className="relative z-10 text-center mb-10" data-id="element-207">
            <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-4" data-id="element-208">
              Comienza a liberar tu espalda
            </h2>
            <p className="text-lg text-warm-dark/70" data-id="element-209">
              Descarga inmediata. Lee a tu ritmo, desde cualquier dispositivo.
            </p>
          </div>

          {/* Price */}
          <div className="text-center mb-10" data-id="element-210">
            <span className="text-xl text-warm-dark/40 line-through font-heading" data-id="element-211">
              $27 USD
            </span>
            <span className="text-5xl font-heading font-bold text-warm-dark block mt-1" data-id="element-212">
              $14.99 USD
            </span>
            <p className="text-sm text-warm-dark/50 mt-2 uppercase tracking-wider" data-id="element-213">
              Pago único
            </p>
          </div>

          {/* Bonuses */}
          <div className="bg-warm-bg/60 rounded-2xl p-6 md:p-8 mb-10 border border-warm-accent/10" data-id="element-214">
            <h4 className="font-heading text-xl text-warm-dark flex items-center justify-center gap-2 mb-6 text-center" data-id="element-215">
              <Gift className="w-5 h-5 text-warm-accent" data-id="element-216" />
              También recibirás Hoy
            </h4>
            <div className="grid sm:grid-cols-2 gap-5" data-id="element-217">
              {bonuses.map((bonus, i) => <div key={i} className="flex gap-3" data-id="element-218">
                  <div className="flex-shrink-0 w-10 h-10 bg-warm-accent/10 rounded-lg flex items-center justify-center" data-id="element-219">
                    {bonus.icon}
                  </div>
                  <div data-id="element-220">
                    <h5 className="font-medium text-warm-dark text-sm mb-1" data-id="element-221">
                      {bonus.title}
                    </h5>
                    <p className="text-xs text-warm-dark/70 leading-relaxed" data-id="element-222">
                      {bonus.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center space-y-6" data-id="element-223">
            <Button href="https://pausaviva.com/cart/47287315398805:1" className="w-full md:w-auto px-12 py-5 text-xl shadow-lg shadow-sage/30" data-id="element-224">
              Comprar Ebook Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-warm-dark/60" data-id="element-225">
              <ShieldCheck className="w-4 h-4" data-id="element-226" />
              <span data-id="element-227">Pago 100% seguro. Acceso inmediato.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}